import fetchModels from "../../mixin/store/api/fetchModels";
import pushModel from "@/mixin/store/api/pushModel";
import fetchModel from "@/mixin/store/api/fetchModel";
import changeModel from "@/mixin/store/api/changeModel";
import deleteModel from "@/mixin/store/api/deleteModel";

export default {
    actions: {
        fetchAllTaxes(context) {
            return fetchModels(context, 'taxes', null, 'updateTaxes');
        },
        fetchTax(context, id) {
            return fetchModel(context, 'taxes', id, 'updateTax')
        },
        deleteTax(context, id) {
            return deleteModel(context, 'taxes', id)
        },
        putTax(context, data) {
            return changeModel(context, 'taxes/' + data.taxId, data, 'updateTax')
        },
        pushTax(context, data) {
            return pushModel(context, 'taxes', data)
        }
    },
    mutations: {
        updateTaxes(state, data) {
            state.taxes = data
        },
        updateTaxesLB(state, data) {
            state.taxes.models = data
        },
        updateTax(state, data) {
            state.tax = data
        }
    },
    state: {
        tax: {},
        taxes: {
            models: [],
            totalItems: 0,
        }
    },
    getters: {
        getTaxes(state) {
            return state.taxes.models
        },
        getTaxesTotalCount(state) {
            return state.taxes.totalItems;
        }
    },
}
